import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./index.scss";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";

const StartScreen = ({handleStartSession, language, videoSrc, source}) => {
    return (
        <div className="start">
           
            <video
                className={`background-video ${source}`}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                src={videoSrc}
                type="video/mp4"
            ></video>
            <div className="start_content">
                <div className={`start_start-button ${source}`} onClick={() => handleStartSession()}>
                {source === "classroom" ? <FontAwesomeIcon icon={faCaretRight} /> : ""}
                <p>{language === "english" ? "start now" : "mulai sekarang"}</p>
                </div>
                <img src={`${process.env.PUBLIC_URL}/assets/bg-footer.png`} alt="" />
            </div>
        </div>
    )
}

export default StartScreen;